require('./index.scss')
import { useSelector } from 'react-redux'

import {
  returnPolicyDaysSelector,
  returnPolicyExplanationTextSelector
} from '@/selectors'
import { translate } from '@/utils/translations'

import ReturnPolicyModal from './ReturnPolicyModal'

const TRANSLATION_KEY = 'return_policy.pdp_tab'

const PolicyStatement = () => {
  const currentPolicyText = useSelector(returnPolicyExplanationTextSelector)
  const isBulkEnabled = useSelector(state => state.currentRegion.bulkEnabled)
  const returnWithinDays = useSelector(returnPolicyDaysSelector)

  return (
    <>
      {translate(`${TRANSLATION_KEY}.easy`)}
      <If condition={!isBulkEnabled}>
        {translate(`${TRANSLATION_KEY}.days`,
          { days: returnWithinDays ?? 30 })}
        {translate(`${TRANSLATION_KEY}.returns`)}
      </If>
      <ReturnPolicyModal />
      {currentPolicyText}
    </>
  )
}

export default PolicyStatement
